module.exports = __webpack_public_path__ + "static/media/6.7387f7e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/6.svg
// module id = 129
// module chunks = 0